import { useEffect } from 'react';
import {
  connect,
  silentReconnect,
  disconnect,
  switchToSepolia,
  attachWalletListeners,
} from '../lib/wallet';
import { useWallet } from '../hooks/useWallet';
import { short } from '../lib/format';

export default function Connect() {
  const wallet = useWallet();

  useEffect(() => {
    silentReconnect();
    attachWalletListeners();
  }, []);

  const onClick = async () => {
    if (wallet.status === 'connected') {
      disconnect();
      return;
    }
    if (wallet.status === 'wrong-network') {
      try { await switchToSepolia(); } catch { /* swallow — store updates */ }
      return;
    }
    await connect();
  };

  const dotColor =
    wallet.status === 'connected'    ? 'var(--green)' :
    wallet.status === 'wrong-network'? 'var(--amber)' :
    wallet.status === 'error'        ? 'var(--red)'   :
    'var(--muted)';

  const dotShadow =
    wallet.status === 'connected'    ? '0 0 8px var(--green)' :
    wallet.status === 'wrong-network'? '0 0 8px var(--amber)' :
    'none';

  const label =
    wallet.status === 'connected'    ? short(wallet.address) :
    wallet.status === 'connecting'   ? 'Connecting…' :
    wallet.status === 'wrong-network'? 'Switch to Sepolia' :
    wallet.status === 'error'        ? 'Retry connect' :
    'Connect';

  const title =
    wallet.status === 'wrong-network' ? `Connected to chain ${wallet.chainId}; click to switch to Sepolia` :
    wallet.status === 'error'         ? wallet.message :
    wallet.status === 'connected'     ? 'Click to disconnect locally' :
    undefined;

  return (
    <button className="connect" onClick={onClick} title={title}>
      <span className="dot" style={{ background: dotColor, boxShadow: dotShadow }} />
      {label}
    </button>
  );
}
